import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { HcSort, HcTableDataSource, PaginationComponent } from '@healthcatalyst/cashmere';
import { Subject, takeUntil } from 'rxjs';
import { DownloadElement, DownloadService } from '../shared/services/download.service';
import { ActivatedRoute } from '@angular/router';

/** Public facing detailed list of available downloads  */
@Component({
    selector: 'pd-downloads-detail',
    templateUrl: './downloads-detail.component.html',
    styleUrls: ['./downloads-detail.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DownloadsDetailComponent implements OnInit, AfterViewInit, OnDestroy {
    private unsubscribe = new Subject<void>();
    dataSource: HcTableDataSource<DownloadElement> = new HcTableDataSource();
    downloadType = '';
    loading = true;
    loadError = false;
    displayedColumns: string[] = ['version', 'name', 'startDate', 'endDate', 'publishDate', 'actions'];
    pageSize: number = 10;
    typeName = '';

    @ViewChild(HcSort)
    sort: HcSort;

    @ViewChild(PaginationComponent)
    paginator: PaginationComponent;

    get listLength(): number {
        return this.dataSource.filteredData ? this.dataSource.filteredData.length : 0;
    }

    constructor (
        private downloadService: DownloadService,
        private route: ActivatedRoute
    ) {}

    ngOnInit(): void {
        this.route.queryParams.pipe(takeUntil(this.unsubscribe)).subscribe(params => {
            if (params['type']) {
                this.downloadType = params['type'];
                if ( this.downloadType === 'techlibrary' ) {
                    this.typeName = 'Technology and Services Catalog';
                } else if ( this.downloadType === 'definitions' ) {
                    this.typeName = 'Catalog Spreadsheet';
                } else if ( this.downloadType === 'metadata' ) {
                    this.typeName = 'Metadata Spreadsheet';
                }
                this.loadDownloads(this.downloadType);
            }
        });
    }

    ngAfterViewInit(): void {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;

        setTimeout(() => {
            this.sort.sort( { disableClear: false, id: 'version', start: 'desc' } );
        });
    }

    loadDownloads(type: string) {
        this.downloadService.downloadsUpdated.pipe(takeUntil(this.unsubscribe)).subscribe(list => {
            if (list) {
                this.loading = false;
                this.loadError = false;
                
                let filteredList: DownloadElement[] = [];
                list.forEach(element => {
                    if ( element.type === type ) {
                        filteredList.push( element );
                    }
                });

                this.dataSource = new HcTableDataSource(filteredList);
                if ( this.sort && this.paginator ) {
                    this.dataSource.sort = this.sort;
                    this.dataSource.paginator = this.paginator;

                    if ( (this.sort.direction !== 'desc' || this.sort.active !== 'version') ) {
                        setTimeout(() => {
                            this.sort.sort( { disableClear: false, id: 'version', start: 'desc' } );
                        });
                    }
                }
            } else {
                this.loadError = this.downloadService.loadFailed;
                if (!this.loadError) {
                    this.downloadService.refresh();
                } else {
                    this.loading = false;
                }
            }
        });
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}